module.exports = __webpack_public_path__ + "static/img/slide_8_fr.e8621cb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/training/slider/slide_8_fr.svg
// module id = UYp5
// module chunks = 0